module.exports = __webpack_public_path__ + "img/icon02.9269db8f.png";